import { useCallback } from "react";
import { SessionManager } from "../../infrastructure/session/SessionManager";

export const useSession = () => {
  const getAccessToken = useCallback(() => {
    const sessionPort = new SessionManager();
    return sessionPort.getAccessToken();
  }, []);

  const getTempAccessToken = useCallback(() => {
    const sessionPort = new SessionManager();
    return sessionPort.getTempAccessToken();
  }, []);

  const getPasswordResetToken = useCallback(() => {
    const sessionPort = new SessionManager();
    return sessionPort.getPasswordResetToken();
  }, []);

  const getUserEmail = useCallback(() => {
    const sessionPort = new SessionManager();
    return sessionPort.getUserEmail();
  }, []);

  const getIsTotpEnabled = useCallback(() => {
    const sessionPort = new SessionManager();
    return sessionPort.getIsTotpEnabled();
  }, []);

  const getTotpEnabled = useCallback(() => {
    const sessionPort = new SessionManager();
    return sessionPort.getTotpEnabled();
  }, []);

  const getIsPasswordSet = useCallback(() => {
    const sessionPort = new SessionManager();
    return sessionPort.getIsPasswordSet();
  }, []);

  const clearSession = useCallback(() => {
    const sessionPort = new SessionManager();
    sessionPort.clearSession();
  }, []);

  return {
    getAccessToken,
    getTempAccessToken,
    getPasswordResetToken,
    getUserEmail,
    getTotpEnabled,
    getIsTotpEnabled,
    getIsPasswordSet,
    clearSession,
  };
};